import { useEffect, useState } from 'react';
import { BsRobot } from 'react-icons/bs';
import { MdClose } from 'react-icons/md';
import { api } from '../services/api';

const VERDE = '#1a3d2a';

// Widget flutuante visível em toda tela autenticada (montado uma vez em
// LayoutPrivado). O assistente ainda não existe de verdade — este
// componente é só a casca visual, com o chat desabilitado e um aviso de
// "em breve". Nenhuma pergunta sai daqui pra nenhuma IA ainda.
export default function AssistenteIAWidget() {
  const [ativo, setAtivo] = useState(false);
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    let cancelado = false;
    api.get('/configuracoes/assistente-ia/status/')
      .then((res) => { if (!cancelado) setAtivo(!!res.data?.ativo); })
      .catch(() => { if (!cancelado) setAtivo(false); });
    return () => { cancelado = true; };
  }, []);

  if (!ativo) return null;

  return (
    <div style={{ position: 'fixed', bottom: '24px', right: '24px', zIndex: 9999 }}>
      {aberto && (
        <div
          style={{
            width: '320px',
            maxWidth: 'calc(100vw - 48px)',
            marginBottom: '12px',
            borderRadius: '12px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.18)',
            background: '#fff',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              background: VERDE, color: '#fff', padding: '14px 16px',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 700 }}>
              <BsRobot size={20} /> Assistente Novalis
            </div>
            <button
              onClick={() => setAberto(false)}
              aria-label="Fechar"
              style={{ background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', display: 'flex' }}
            >
              <MdClose size={20} />
            </button>
          </div>

          <div style={{ padding: '20px 16px', textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: '8px' }}>🤖</div>
            <p style={{ fontWeight: 700, color: '#1a3d2a', marginBottom: '6px' }}>Em breve!</p>
            <p style={{ fontSize: '.85rem', color: '#6b7280', lineHeight: 1.5 }}>
              Estamos preparando um assistente pra tirar dúvidas sobre o sistema e ajudar com
              análises rápidas, direto em qualquer tela.
            </p>
          </div>

          <div style={{ padding: '0 16px 16px' }}>
            <input
              disabled
              placeholder="Em breve você poderá perguntar aqui..."
              style={{
                width: '100%', padding: '10px 12px', borderRadius: '8px',
                border: '1px solid #e5e7eb', background: '#f9fafb', color: '#9ca3af',
                fontSize: '.85rem', cursor: 'not-allowed',
              }}
            />
          </div>
        </div>
      )}

      <button
        onClick={() => setAberto((v) => !v)}
        aria-label="Assistente de IA"
        style={{
          width: '56px', height: '56px', borderRadius: '50%',
          background: VERDE, color: '#fff', border: 'none',
          boxShadow: '0 6px 16px rgba(0,0,0,0.25)', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginLeft: 'auto',
        }}
      >
        {aberto ? <MdClose size={24} /> : <BsRobot size={26} />}
      </button>
    </div>
  );
}
